import { render } from "./CircleButton.vue?vue&type=template&id=4988553d&scoped=true"
import script from "./CircleButton.vue?vue&type=script&lang=js"
export * from "./CircleButton.vue?vue&type=script&lang=js"

import "./CircleButton.vue?vue&type=style&index=0&id=4988553d&lang=scss&scoped=true"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4988553d"]])

export default __exports__